import type { FC } from "react";
import SkeletonBox from "./SkeletonBox";

const SkeletonCard: FC = () => (
  <SkeletonBox h="200px" w="100%" borderRadius={10} withSpinner />
);

export default SkeletonCard;
